import { Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const ErrorPage = () => {
    const { t } = useTranslation("errors");

    return (
        <div className="bg-white flex flex-col items-center justify-center h-screen p-6">
            <div className="text-center flex flex-col items-center gap-2">
                <img
                    src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f9a7/512.gif"
                    alt="🦧"
                    width="120"
                    height="120"
                    className="mb-2"
                />
                <Typography.Title level={2}>
                    {t("serviceUnavailableHeader")}
                </Typography.Title>
                <Typography.Paragraph type="secondary">
                    {t("serviceUnavailableSubheader")}
                </Typography.Paragraph>
            </div>
        </div>
    );
};

export default ErrorPage;